import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance1wcuorfuztxv3 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.l5y_1 = call;
        this.m5y_1 = responseData.p5m_1;
        this.n5y_1 = responseData.k5m_1;
        this.o5y_1 = responseData.n5m_1;
        this.p5y_1 = responseData.l5m_1;
        this.q5y_1 = responseData.q5m_1;
        var tmp = this;
        var tmp_0 = responseData.o5m_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.r5y_1 = tmp0_elvis_lhs == null ? Companion_getInstance().t4n_1 : tmp0_elvis_lhs;
        this.s5y_1 = responseData.m5m_1;
      }
      v5l() {
        return this.l5y_1;
      }
      ww() {
        return this.m5y_1;
      }
      e5m() {
        return this.n5y_1;
      }
      f5m() {
        return this.o5y_1;
      }
      g5m() {
        return this.p5y_1;
      }
      h5m() {
        return this.q5y_1;
      }
      d5m() {
        return this.r5y_1;
      }
      u54() {
        return this.s5y_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
